import { FC, ReactNode } from 'react';

import styles from './Paragraph.module.scss';
type ParagraphProps = {
  children: ReactNode;
  addClass?: string[];
};
export const Paragraph: FC<ParagraphProps> = ({ children, addClass = [] }) => {
  return <p className={[styles.paragraph, ...addClass].join(' ')}>{children}</p>;
};
